import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './App'
import { queryClient } from './lib/queryClient'
import './index.css'

// TASK-739: data router (single splat route hosting the existing <Routes> tree
// in App) — the minimal migration that unlocks useBlocker, so in-app navigation
// away from a dirty workbench document can prompt. Route definitions stay in
// App; only the router type changed.
const router = createBrowserRouter(
  [{ path: '*', element: <App /> }],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <Toaster
        position="top-right"
        theme="dark"
        duration={4000}
        toastOptions={{
          style: {
            background: '#1f2937',
            color: '#f9fafb',
            border: '1px solid #374151',
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>
)
